import { useEffect, useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { FiberManualRecord, RemoveRedEyeOutlined } from "@mui/icons-material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { routeName } from "../../../../routes/routeName";
import { useTranslation } from "react-i18next";
import { StudentApi } from "../../../../api/student/student.api";

const EducationHistory = ({
  student_id,
  student_data,
  id_student_register_payment,
  id_student_term_payment,
}: {
  student_id: number;
  student_data: any;
  id_student_register_payment: number;
  id_student_term_payment: number;
}) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();

  const [data, setData] = useState<any>([]);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, _setTotalItems] = useState<number>();
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "year",
      width: 15,
      disablePadding: false,
      align: "start",
      label: t("STUDENT_MANAGEMENT.EDUCATION_HISTORY.TABLE.CLASS_YEAR_COLUMN"),
    },
    {
      id: "year_study",
      disablePadding: false,
      width: 15,
      align: "center",
      label: t("STUDENT_MANAGEMENT.EDUCATION_HISTORY.TABLE.STUDY_YEAR_COLUMN"),
    },
    {
      id: "term",
      disablePadding: false,
      align: "center",
      width: 15,
      label: t("STUDENT_MANAGEMENT.EDUCATION_HISTORY.TABLE.TERM_COLUMN"),
    },
    {
      id: "gpa",
      disablePadding: false,
      align: "center",
      width: 10,
      label: t("STUDENT_MANAGEMENT.EDUCATION_HISTORY.TABLE.GPA_COLUMN"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 35,
      label: t(
        "STUDENT_MANAGEMENT.EDUCATION_HISTORY.TABLE.STUDENT_STATUS_COLUMN"
      ),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_student_educational,
      id_student,
      year,
      year_study,
      term,
      gpa,
      status,
    } = objData;

    const objRenderData = {
      key: id_student_educational,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${year}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: year_study || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: term || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: gpa || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={
                status === "active" ? t("เป็นนักศึกษา") : t("ไม่ได้เป็นนักศึกษา")
              }
              type="outlined"
              color={status === "active" ? "success" : "error"}
              icon={<FiberManualRecord />}
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <RemoveRedEyeOutlined
              // student_data,

              onClick={() => {
                const fullname =
                  student_data.section_1.title +
                  "" +
                  student_data.section_1.first_name +
                  "" +
                  student_data.section_1.last_name;
                navigate(
                  routeName.cms.ManageStudents +
                  `/education-info/term/${id_student_educational}?id_student=${id_student}&id_student_register_payment=${id_student_register_payment}&id_student_term_payment=${id_student_term_payment}&fullname=${fullname}&middle_name=${student_data.section_1.middle_name
                  }&course=${"-"}`
                );
              }}
              style={{
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const getEducationHistory = async (student_id: number) => {
    const res = await StudentApi.fetchGetEducationHistory(student_id);
    const data = res.data;
    if (data.status < 300) {
      setData(data.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (student_id) {
      getEducationHistory(student_id);
    }
  }, [student_id]);

  return (
    <section className="w-full mt-10">
      <TableCustom
        tableMinWidth={1440}
        tableFixedWidth
        customScroll
        page={page}
        pageLimit={pageLimit}
        sortBy={sortBy}
        sortType={sortType}
        headCells={headCells}
        rowCount={totalItems}
        rowsData={
          data &&
          data.map((data: any, i: any) => {
            return renderData(data, i);
          })
        }
        onSort={handleRequestSort}
        setPageLimit={(value: number) => setPageLimit(value)}
        setPage={(value: number) => setPage(value)}
      />
    </section>
  );
};

export default EducationHistory;
